import {
  MeetingSVG,
  PartySVG,
  DiningSVG,
  TeamActivitySVG,
  PresentationSVG,
  WeddingSVG,
  NetworkingSVG,
  StudioSVG,
  ConferenceSVG,
  SomethingElseSVG,
} from './Illustrations'

const Illustrations: Record<string, JSX.Element> = {
  'Meeting/Workshop': <MeetingSVG />,
  Party: <PartySVG />,
  'Private Dining': <DiningSVG />,
  'Team Activity': <TeamActivitySVG />,
  Presentation: <PresentationSVG />,
  Wedding: <WeddingSVG />,
  Networking: <NetworkingSVG />,
  Studio: <StudioSVG />,
  Conference: <ConferenceSVG />,
  'Something else': <SomethingElseSVG />,
}

export const EventIllustration = ({
  eventType,
}: {
  eventType: string
}): JSX.Element => {
  return Illustrations[eventType]
}
